import { gql } from "@apollo/client";

export const GET_PROTECTION_PLANS = gql`
  query protectionPlans{
    protectionPlans {
      id
      name
      description
      excess
      code
    }
  }
`;
